import { Component, Element, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'pn-share-item',
  styleUrl: 'pn-share-item.scss',
})
export class PnShareItem {
  @Element() hostElement: HTMLElement;
  @Prop() link: string = null;
  @Prop() text: string = null;

  render() {
    return (
      <Host>
        <div class="pn-share-item__container">
          <a href={`${this.link}`}>
            <slot name="icon" /> {this.text}
          </a>
        </div>
      </Host>
    );
  }
}
